const PREFIX = 'prevencor_draft_';

export const localDraftStorage = {
  saveDraft(formType, recordId, data) {
    if (!recordId) return;
    const key = `${PREFIX}${formType}_${recordId}`;
    const payload = {
      data,
      updatedAt: new Date().toISOString(),
    };
    try {
      localStorage.setItem(key, JSON.stringify(payload));
    } catch (err) {
      console.warn('Erro ao gravar rascunho local:', err);
    }
  },

  getDraft(formType, recordId) {
    if (!recordId) return null;
    const key = `${PREFIX}${formType}_${recordId}`;
    try {
      const raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },

  removeDraft(formType, recordId) {
    if (!recordId) return;
    const key = `${PREFIX}${formType}_${recordId}`;
    try {
      localStorage.removeItem(key);
    } catch (err) {
      console.warn('Erro ao remover rascunho local:', err);
    }
  },
};
